import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer style={{ backgroundColor: "#1f4e3d", color: "#fff", padding: "40px 20px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ maxWidth: "1300px", margin: "auto", display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "30px" }}>
        {/* Şirket Bilgisi */}
        <div style={{ flex: "1 1 250px" }}>
          <h3 style={{ fontSize: "22px", marginBottom: "15px", fontFamily: "'Cormorant Garamond', serif" }}>MİNHALTURİZM</h3>
          <p style={{ fontSize: "14px", lineHeight: "1.6" }}>
            Hac, Umre, Kültür Turları ve daha fazlası için güvenilir adres. Yılların deneyimiyle hizmetinizdeyiz.
          </p>
        </div>

        {/* Hızlı Bağlantılar */}
        <div style={{ flex: "1 1 180px" }}>
          <h4 style={{ fontSize: "18px", marginBottom: "12px" }}>Bağlantılar</h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, lineHeight: "1.8" }}>
            <li><Link to="/hac" style={linkStyle}>Hac</Link></li>
            <li><Link to="/umre" style={linkStyle}>Umre</Link></li>
            <li><Link to="/kultur-turlari" style={linkStyle}>Kültür Turları</Link></li>
            <li><Link to="/ucak-bileti" style={linkStyle}>Uçak Bileti</Link></li>
            <li><Link to="/iletisim" style={linkStyle}>İletişim</Link></li>
          </ul>
        </div>

        {/* İletişim */}
        <div style={{ flex: "1 1 220px" }}>
          <h4 style={{ fontSize: "18px", marginBottom: "12px" }}>İletişim</h4>
          <p style={infoText}>📍 İstanbul, Türkiye</p>
          <p style={infoText}>📞 +90 555 555 55 55</p>
          <p style={infoText}>✉️ info@minhalturizm.com</p>
        </div>
      </div>

      {/* Alt Kısım */}
      <div style={{ borderTop: "1px solid #ffffff33", marginTop: "30px", paddingTop: "20px", textAlign: "center", fontSize: "14px", opacity: 0.85 }}>
        © {new Date().getFullYear()} Minhal Turizm. Tüm hakları saklıdır.
      </div>
    </footer>
  );
}

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "15px",
  transition: "color 0.2s",
};

const infoText = {
  fontSize: "14px",
  marginBottom: "6px",
};

export default Footer;
